import { Reveal } from "./Reveal";
import { Phone, Check } from "lucide-react";

const includes = ["Whole House Soft Wash", "Driveway Cleaning", "Walkway Cleaning"];

export const Promo = () => (
  <section className="py-24 sm:py-32 bg-fr-red relative overflow-hidden" data-testid="promo-section">
    <div className="absolute -right-20 -top-20 w-96 h-96 rounded-full bg-white/10 blur-3xl" />
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10 relative z-10">
      <div className="grid lg:grid-cols-2 gap-12 items-center">
        <Reveal>
          <span className="fr-mono text-xs tracking-[0.3em] uppercase text-white/80">/ Limited-time special</span>
          <h2 className="mt-5 font-display font-bold text-4xl sm:text-6xl lg:text-7xl tracking-tighter leading-[0.9] text-white">
            WHOLE HOUSE WASH
          </h2>
          <div className="mt-6 space-y-3">
            {includes.map((i) => (
              <div key={i} className="flex items-center gap-3 text-white">
                <Check size={20} className="shrink-0" strokeWidth={3} />
                <span className="text-lg font-semibold">{i}</span>
              </div>
            ))}
          </div>
        </Reveal>

        <Reveal delay={0.15} className="flex flex-col items-start lg:items-end">
          <div className="text-white text-right w-full lg:w-auto">
            <span className="fr-mono text-sm tracking-widest uppercase text-white/70">Only</span>
            <div className="font-display font-bold text-white text-[7rem] sm:text-[9rem] leading-none tracking-tighter">$380</div>
            <p className="fr-mono text-xs tracking-[0.25em] uppercase text-white/80 -mt-2">Bundle price · save more</p>
          </div>
          <a
            href="#estimate"
            data-testid="promo-claim-btn"
            className="mt-8 bg-fr-black text-white font-bold rounded-sm px-8 py-4 hover:bg-white hover:text-fr-black transition-colors inline-flex items-center gap-2"
          >
            <Phone size={17} /> Claim This Deal
          </a>
        </Reveal>
      </div>
    </div>
  </section>
);
